
import { ISurveyAnswerDto } from "../../models/dto/surveyApi/ISurveyAnswerDto";
import * as ApiWithToken from "../callApiWithToken";

const solveSurveyService = {
    postSurveyAnswers: async function (surveyAnswer: ISurveyAnswerDto) {
        return ApiWithToken.postApi(process.env.REACT_APP_SURVEY_API + `SolveSurvey/surveyAnswers`, surveyAnswer);
    },
}
export default solveSurveyService;
